import React, { useState } from 'react';
import {
  GeckoModal,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
} from '../../../ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { GeckoAlert } from '../../../ui';

const MassCloseConversationModal = ({ setActionTimestamp, massAction }) => {
  const [actionTriggered, setActionTriggered] = useState(false);

  const pluralize = (word, count) => {
    return count === 1 ? word : word + 's';
  };

  return (
    <GeckoModal
      name="Close conversations"
      children={
        <div>
          <GeckoAlert type={'warning'}>
            {actionTriggered
              ? `Closing ${massAction.selected.length} ${pluralize(
                  'conversation',
                  massAction
                )}.`
              : `${massAction.selected.length} ${pluralize(
                  'conversation',
                  massAction
                )} will be closed.`}
          </GeckoAlert>
        </div>
      }
      btns={[
        {
          name: 'Cancel',
          secondary: true,
          icon: 'fa fa-times',
          handler: () => {
            return new GeckoModalService().close();
          },
          hideWhen: () => {
            return actionTriggered;
          },
        },
        {
          type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
          name: actionTriggered ? 'Closing' : 'Done',
          icon: actionTriggered ? 'far fa-spinner spin' : 'fa fa-check-double',
          disabledWhen: () => {
            return !massAction.selected.length || actionTriggered;
          },
          handler: () => {
            setActionTriggered(true);
            GeckoRequest.post(`/conversation/mass-status`, {
              conversationIds: massAction.selected,
              status: 'closed',
            })
              .then(() => {
                console.log('CLOSE:  .THEN');
                setActionTriggered(false);
                setActionTimestamp(Date.now());
                console.log('CLOSE:  sate set');
                new GeckoToastService().success(
                  'Mass close assignment complete'
                );
                console.log('CLOSE: toast triggered');
                new GeckoModalService().close();
                console.log('CLOSE: modal service close');
              })
              .catch((err) => {
                new GeckoModalService().close();
                setActionTriggered(false);
                new GeckoToastService().error(
                  'Mass conversation close failed. Please try again. If the problem persists please contact support.'
                );
              });
          },
        },
      ]}
    />
  );
};

export default MassCloseConversationModal;
